import { HelpCircle } from 'lucide-react';
import type { FAQBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const faqConfig: BlockTypeConfig<FAQBlock> = {
  type: 'faq',
  label: 'FAQ',
  description: 'Accordion-style frequently asked questions',
  icon: HelpCircle,
  category: 'interactive',
  createDefault: () => ({
    items: [
      {
        id: crypto.randomUUID(),
        question: 'First question',
        answer: '<p>First answer.</p>',
      },
      {
        id: crypto.randomUUID(),
        question: 'Second question',
        answer: '<p>Second answer.</p>',
      },
    ],
    style: 'accordion',
    accordionStyle: 'bordered',
    accordionIcon: 'chevron',
    allowMultipleOpen: false,
    defaultOpen: 'none',
    numbered: false,
    density: 'default',
  }),
  toolbar: [
    {
      kind: 'select',
      path: 'data.style',
      label: 'Style',
      options: [
        { value: 'accordion', label: 'Accordion' },
        { value: 'list', label: 'List' },
      ],
    },
    {
      kind: 'select',
      path: 'data.accordionStyle',
      label: 'Container',
      options: [
        { value: 'bordered', label: 'Bordered' },
        { value: 'separated', label: 'Separated' },
        { value: 'borderless', label: 'Borderless' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  sheet: [
    {
      kind: 'group',
      label: 'Heading',
      fields: [
        { kind: 'text', path: 'data.title', label: 'Title' },
        { kind: 'text', path: 'data.subtitle', label: 'Subtitle' },
      ],
    },
    {
      kind: 'group',
      label: 'Accordion appearance',
      fields: [
        {
          kind: 'select',
          path: 'data.accordionIcon',
          label: 'Icon',
          options: [
            { value: 'chevron', label: 'Chevron' },
            { value: 'plus', label: 'Plus / minus' },
            { value: 'arrow', label: 'Arrow' },
            { value: 'none', label: 'None' },
          ],
        },
        {
          kind: 'select',
          path: 'data.density',
          label: 'Density',
          options: [
            { value: 'compact', label: 'Compact' },
            { value: 'default', label: 'Default' },
            { value: 'loose', label: 'Loose' },
          ],
        },
        { kind: 'toggle', path: 'data.numbered', label: 'Number questions' },
      ],
    },
    {
      kind: 'group',
      label: 'Behaviour',
      fields: [
        {
          kind: 'select',
          path: 'data.defaultOpen',
          label: 'Default open',
          options: [
            { value: 'none', label: 'None' },
            { value: 'first', label: 'First item' },
            { value: 'all', label: 'All items' },
          ],
        },
        {
          kind: 'toggle',
          path: 'data.allowMultipleOpen',
          label: 'Allow multiple open at once',
        },
      ],
    },
  ],
  repeatingItems: {
    arrayPath: 'data.items',
    itemFactory: () => ({
      id: crypto.randomUUID(),
      question: 'New question',
      answer: '<p>Answer goes here.</p>',
    }),
    addLabel: 'Add FAQ item',
  },
};
